import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

export const StyledBoxApps = styled.div`
  background-color: ${props => props.theme.colors.light};
  // height: 100%;
  margin-top: 0;
  padding: ${rem('12px')} ${rem('26px')};
  position: relative;
  transition: initial 0.4s initial ease-in-out;
  width: 100%;

  &:after {
    border-left: ${rem('10px')} solid transparent;
    border-right: ${rem('10px')} solid transparent;
    border-top: ${rem('12px')} solid ${props => props.theme.colors.light};
    content: '';
    display: none;
    height: 0;
    position: absolute;
    right: 0;
    top: ${rem('-2px')};
    width: 0;

    ${mediaqueries.greaterThan('desktop')`
        display: block;
    `};
  }

  ${mediaqueries.greaterThan('mobile')`
    margin-top: 0;
    max-width: ${rem('482px')};
    padding: ${rem('12px')} ${rem('43px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    padding: ${rem('9px')} ${rem('8px')} 0 ${rem('9px')};
    height: 65vh;
    overflow-y: auto;
  `};
`;

export const StyledIconCollapse = styled(Icon)`
  display: none;
  position: absolute;
  right: ${rem('2px')};
  top: ${rem('-6px')};
  z-index: 1;

  ${mediaqueries.greaterThan('desktop')`
    display: block;
  `};
`;

export const StyledIconCloseApps = styled(Icon)`
  display: none;
  left: ${rem('19px')};
  position: absolute;
  top: ${rem('19px')};

  ${mediaqueries.lessThan('mobile')`
    display: block;
    fill: ${props => props.theme.colors.primary};
    height: ${rem('19px')};
    width: ${rem('19px')};
  `};
`;

export const StyledTitleApps = styled.div`
  color: ${props => props.theme.colors.dark};
  font-family: ${props => props.theme.fonts.medium};
  font-weight: 900;
  font-size: large;
  margin-bottom: ${rem('25px')};
  padding-bottom: ${rem('11px')};
  padding: 15px 0px 0 15px;
  text-transform: uppercase;

  ${mediaqueries.greaterThan('mobile')`
    margin-bottom: ${rem('6px')};
    padding: 15px 0px 0 15px;
  `};

  ${mediaqueries.lessThan('desktop')`
    margin-bottom: ${rem('38px')};
    padding: 15px 0px 0 0px;
  `}

  ${mediaqueries.greaterThan('desktop')`
    font-size: ${props => props.theme.fontSize.medium};
    margin-bottom: ${rem('15px')};
  `};
`;

export const StyledIconArrow = styled(Icon)`
  display: none;

  ${mediaqueries.between('mobile', 'desktop')`
    display: inline-block;
    margin-right: ${rem('12px')};
    transform: rotate(180deg);
    width: ${rem('14px')};  
  `};
`;
